import * as React from "react";

const PAPER_LINK = "https://siqef.phbs.pku.edu.cn/paper/20240906.pdf";
const PAPER_TITLE = "基于大数据的区域经济预测——以广东省和深圳市经济预测为例";

const NATIONAL_REPORT_LINK =
  "https://thinktank.phbs.pku.edu.cn/2025niandiyijiduhongguanjingjifenxibaogao.pdf";
const NATIONAL_REPORT_TITLE = "北大汇丰智库宏观经济分析报告：2025年第一季度";

const GBA_REPORT_LINK =
  "https://thinktank.phbs.pku.edu.cn/2025nianyijiduyuegangaodawanqujingjifenxibaogao.pdf";
const GBA_REPORT_TITLE = "北大汇丰智库粤港澳大湾区经济分析报告：2025年第一季度";

export default function RelatedResearch() {
  const [hoverIndex, setHoverIndex] = React.useState(null);

  const linkStyle = (index) => ({
    color: "#0057b7", // 默认蓝色
    textDecoration: hoverIndex === index ? "underline" : "none", // 悬浮显示下划线
    transition: "all 0.2s ease",
  });

  return (
    <div className="intro">
      <h2>
        {" 相关研究 "}
        <small>Related Research</small>
      </h2>

      <p className="relaResearch">
        全国GDP的预测模型与方法请参考北大汇丰研究报告{" "}
        <a
          href={NATIONAL_REPORT_LINK}
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle(0)}
          onMouseEnter={() => setHoverIndex(0)}
          onMouseLeave={() => setHoverIndex(null)}
        >
          《{NATIONAL_REPORT_TITLE}》
        </a>
        。
      </p>

      <p className="relaResearch">
        珠三角九市GDP的经济预测模型与方法请参考北大汇丰研究报告{" "}
        <a
          href={GBA_REPORT_LINK}
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle(1)}
          onMouseEnter={() => setHoverIndex(1)}
          onMouseLeave={() => setHoverIndex(null)}
        >
          《{GBA_REPORT_TITLE}》
        </a>
        。
      </p>

      <p className="relaResearch">
        广东省与深圳市的区域经济指标预测模型与方法，主要参考萨金特数量经济与金融研究所的工作论文{" "}
        <a
          href={PAPER_LINK}
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle(2)}
          onMouseEnter={() => setHoverIndex(2)}
          onMouseLeave={() => setHoverIndex(null)}
        >
          《{PAPER_TITLE}》
        </a>
        。该研究系统阐述了区域经济预测中的计量模型与机器学习模型的集成方法。
      </p>
    </div>
  );
}
